<template>
 <div class="analtics"  :class="{ 'map-visible-top': isMapVisible }">
  <DescriptionModal class="description-modal"
    :style="{ top: show === false ? '-50px' : '-90px'}"
    :description="`This section helps determine how many people answered different types of questions during the kit activation process.`" />
    <city-state-filter v-if="show===false" ></city-state-filter>
    <div class="container" :class="{ 'map-visible': isMapVisible }">
    <AnalyticsCount @shows="setShow" v-if="show===false" ></AnalyticsCount>
    <AnalyticsList v-if="show===true && !isMapVisible"
        @showModal="showModal"
        @showComment="showComment"
    ></AnalyticsList>
    <template v-if="show===false">
       <Map></Map>
    </template>
     
    </div>
 </div>
</template>
<script>
import { mapGetters,mapActions } from "vuex";
import AnalyticsCount from "./analytics/AnalyticsCount.vue";
import AnalyticsList from "./analytics/AnalyticsList.vue";
import CityStateFilter from './research/CityStateFilter.vue';
import Map from "./research/Map.vue";
export default {
  name: "Analytics",
  data(){
    return {
        show: false,
    };
  },
  components:{
      AnalyticsCount,
      AnalyticsList,
      Map,
    CityStateFilter
  },
  watch:{
    getAnalyticsStatus(obj) {
      this.setAnaltics(obj.show);
      this.show = obj.show;
    }
  },
  computed:{
    ...mapGetters(["getAnalyticsStatus","isMapVisible"])
  },
  methods:{
    ...mapActions([
        "setAnaltics"
    ]),
    setShow(obj){
       this.setAnaltics(obj.show);
       this.show = obj.show;
    },
    showModal(boolean) {
      this.$emit("showModal", boolean);
    },
    showComment(obj) {
      this.$emit("showComment", obj);
    },
  },
}
</script>
<style scoped>
.description-modal{
  text-align: end;
  position: absolute;
  z-index: 1;
  width: 100%;
}
.analtics {
  background-color: #e6ecf0;
  max-width: 100%;
  width: 100vw;
  min-height: 95vh;
  position: relative;
}
.map-visible {
  margin-bottom: 20px;
  bottom: 10px;
}
.map-visible-top{
  top: 30px;
}
@media print {
  .analtics {
    min-height: 10vh;
  }
}
</style>
